import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconBusinessAccountFill from './icon-business-account-fill.vue';

const IconBusinessAccountFill = Object.assign(_IconBusinessAccountFill, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconBusinessAccountFill.name, _IconBusinessAccountFill);
  }
});

export default IconBusinessAccountFill;
